import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import OurWork from "./components/OurWork";
import ServiceAreasDetailed from "./components/ServiceAreasDetailed";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import { translations } from "./data/mock";
import { Toaster } from "./components/ui/sonner";

function App() {
  // Detect browser language on component mount
  const detectBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.languages[0];
    if (browserLang.startsWith('he')) return 'he';
    if (browserLang.startsWith('ru')) return 'ru';
    return 'en'; // Default fallback
  };

  const [currentLang, setCurrentLang] = useState(detectBrowserLanguage());

  // Update document direction and meta tags for RTL support and SEO
  useEffect(() => {
    document.documentElement.dir = currentLang === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
    
    // Update meta tags based on language
    const titles = {
      en: "Mobile Car Key Service Israel 24/7 | Emergency Auto Locksmith | XKey24",
      he: "יצור מפתחות רכב עם הגעה ישראל 24/7 | מומחה מפתחות חירום | XKey24", 
      ru: "Изготовление ключей авто с выездом Израиль 24/7 | Мастер по ключам | XKey24"
    };
    
    const descriptions = {
      en: "Professional mobile car key service across Israel. 24/7 emergency locksmith, car key duplication, transponder programming, keyless entry repair. Same-day service in Tel Aviv, Haifa, Jerusalem. Call +972-55-300-2025",
      he: "שירות יצור מפתחות רכב עם הגעה ברחבי ישראל. מומחה חירום 24/7, העתקת מפתחות רכב, תכנות טרנספונדר, תיקון מערכת keyless. שירות ביום בתל אביב, חיפה, ירושלים. חייגו 972-55-300-2025+",
      ru: "Профессиональное изготовление ключей авто с выездом по Израилю. Экстренный мастер 24/7, дубликат чип-ключа, программирование транспондера, ремонт keyless. Обслуживание в день обращения в Тель-Авиве, Хайфе, Иерусалиме. Звоните +972-55-300-2025"
    };
    
    document.title = titles[currentLang];
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = descriptions[currentLang];
    }
  }, [currentLang]);

  return (
    <div className={`App ${currentLang === 'he' ? 'rtl' : 'ltr'} relative`}>
      <AnimatedBackground />
      <Header 
        currentLang={currentLang} 
        setCurrentLang={setCurrentLang} 
        translations={translations}
      />
      <Hero 
        currentLang={currentLang} 
        translations={translations}
      />
      <Services 
        currentLang={currentLang} 
        translations={translations}
      />
      <About 
        currentLang={currentLang} 
        translations={translations}
      />
      <OurWork 
        currentLang={currentLang} 
        translations={translations}
      />
      <ServiceAreasDetailed 
        currentLang={currentLang} 
        translations={translations}
      />
      <Testimonials 
        currentLang={currentLang} 
        translations={translations}
      />
      <Contact 
        currentLang={currentLang} 
        translations={translations}
      />
      <Footer 
        currentLang={currentLang} 
        translations={translations}
      />
      <Toaster />
    </div>
  );
}

export default App;